import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import {
  BodyTextSmall, HeadlineTextSmall,
} from 'Packages/FacetDesign/Components';
import {
  useSmartAllocationCustomizationContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Templates/SmartAllocationCustomizationPicker/NewSmartAllocationCustomization/Context';
import SACStepWithOptionalLozenge
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Templates/SmartAllocationCustomizationPicker/NewSmartAllocationCustomization/Content/SmartAutoCustomizationGroupsPicker/SmartAutoCustomizationGroups/SmartAutoCustomizationGroupList/Step';
import SmartAutoCustomizationGroupList from './SmartAutoCustomizationGroupList';
import AssumptionsForm from './AssumptionsForm';

const SmartAutoCustomizationGroup = ({
  groupResource,
}) => {
  const {
    optimisticUpdateSacGroup,
    isOptimisticallyUpdating,
    sacGroupsCollection,
  } = useSmartAllocationCustomizationContext();
  return (
    <FDStack direction={'column'} spacing={1}>
      <FDStack direction={'column'} spacing={2}>
        <HeadlineTextSmall
          color={'textSecondary'}
          value={groupResource.selectedOptionPrompt('title')}
        />
        <BodyTextSmall value={groupResource.selectedOptionPrompt('description')} />
      </FDStack>
      {(groupResource.attr('title') === 'restIntoBrokerage') ? (
        <AssumptionsForm />
      ) : null}
      <SmartAutoCustomizationGroupList
        StepComponent={SACStepWithOptionalLozenge}
        groupResource={groupResource}
        optimisticUpdateSacGroup={optimisticUpdateSacGroup}
        isOptimisticallyUpdating={isOptimisticallyUpdating}
        sacGroupsCollection={sacGroupsCollection}
        showActiveStatus
      />
    </FDStack>
  );
};

SmartAutoCustomizationGroup.propTypes = {
  groupResource: PropTypes.object.isRequired,
};

export default SmartAutoCustomizationGroup;
